

export const generateUniqueNumber = (max: number = 1000) => {
    let number = Math.floor(Math.random() * max);
    if(number === 0) number =  Math.floor(Math.random() * max);

    return number;
}
